// extracted by mini-css-extract-plugin
module.exports = {"uikit-context-block":"uikit-context-block__NaNZs","uikit-context-block__item":"uikit-context-block__item__FBUNC"};